// extracted by mini-css-extract-plugin
module.exports = {"countDown":"styles_countDown__3UtpF","group":"styles_group__1jTd-","number":"styles_number__1G_c8","separator":"styles_separator__Y1CkR"};